var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('strong',{staticClass:"badge",class:[_vm.fontFamily, _vm.color, {solid: _vm.isSolid}, {bold: _vm.bold}, _vm.size]},[_vm._t("default",[_vm._v(_vm._s(_vm.value))])],2)}
var staticRenderFns = []

export { render, staticRenderFns }